import { useEffect, useRef } from 'react';

import { useCRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import type { ICartEntry } from '@rbi-ctg/menu';

/**
 * Hook to handle checkout event logging only once when cart entries change.
 *
 */
export const useCheckoutEventLogging = (cartEntries: ICartEntry[]) => {
  const { logCheckoutEvent } = useCRMEventsContext();
  const { serviceMode } = useServiceModeContext();
  const { isStoreAvailable } = useStoreContext();

  const loggedCartStateRef = useRef<string>('');

  useEffect(() => {
    if (!isStoreAvailable || !serviceMode) {
      return;
    }

    const cartStateHash = JSON.stringify(
      cartEntries.map(entry => ({
        cartId: entry.cartId,
        quantity: entry.quantity,
        price: entry.price,
      }))
    );

    if (loggedCartStateRef.current !== cartStateHash && cartEntries.length > 0) {
      loggedCartStateRef.current = cartStateHash;
      logCheckoutEvent(serviceMode, cartEntries);
    }
  }, [cartEntries, serviceMode, isStoreAvailable, logCheckoutEvent]);
};
